import Vue from 'vue';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';

import App from './components/App.vue';
import store from './store';
import { initializeLibs } from './utils/loader';
import { router } from './router';
import { logBuildInfo } from './utils/env.js';

// Docs: https://github.com/ankurk91/vue-toast-notification/tree/v1.x
Vue.use(VueToast);

Vue.filter('drmenv', (v) => {
  if (!v) return '';
  switch (v.env) {
    case 'DRMtodayOnboard': return 'Onboard';
    case 'DRMtoday_STAGING': return 'Staging';
    case 'DRMtoday_TESTING': return 'Test';
    case 'DRMtoday': return 'Prod';
  }
  return v.env;
});

Vue.filter('contentType', (v) => {
  if (!v) return '';
  switch (v) {
    case 'application/dash+xml':
      return 'MPEG-DASH';
    case 'application/x-mpegurl':
      return 'HLS';
    case 'application/vnd.ms-sstr+xml':
      return 'Smooth Streaming';
    case 'video/mp4':
      return 'MP4';
    default:
      return v;
  }
});

Vue.filter('shorten', (v) => {
  if (!v) return '';
  return v.substr(0, 33) + '...';
});

Vue.filter('positive', (v) => {
  if (!v) return '';
  return v >= 0 ? v : '';
});

Vue.filter('utcTime', (v) => {
  if (!v) return '';
  if (!v.toUTCString) return v;
  return v.toUTCString().split(' ')[4];
});

if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

initializeLibs();

const createVueApp = () => {
  return new Vue({
    el: '#app',
    store,
    router,
    render: h => h(App)
  });
};

if (window.location.href.indexOf('http') === 0) {
  logBuildInfo();
  createVueApp();
}
